const isWhitespaceChar = (char) => (
  char === ' '
  || char === '\n'
  || char === '\t'
  || char === '\r'
  || char === '\f'
  || char === '\v'
);

const collapseWhitespace = (value) => {
  let result = '';
  let sawWhitespace = false;
  for (let i = 0; i < value.length; i += 1) {
    const char = value[i];
    if (isWhitespaceChar(char)) {
      if (!sawWhitespace) {
        result += ' ';
        sawWhitespace = true;
      }
    } else {
      result += char;
      sawWhitespace = false;
    }
  }
  return result.trim();
};

const normalizeTagForSearch = (tag) => {
  let normalized = '';
  for (let i = 0; i < tag.length; i += 1) {
    const char = tag[i];
    if (char === '"' || char === "'" || isWhitespaceChar(char)) continue;
    normalized += char;
  }
  return normalized;
};

const containsRedFontTag = (message) => {
  if (!message || typeof message !== 'string') return false;
  const lower = message.toLowerCase();
  let index = 0;
  while (index < lower.length) {
    const tagStart = lower.indexOf('<font', index);
    if (tagStart === -1) return false;
    const tagEnd = lower.indexOf('>', tagStart);
    if (tagEnd === -1) return false;
    const tag = normalizeTagForSearch(lower.slice(tagStart, tagEnd + 1));
    if (tag.includes('<font') && tag.includes('color=red')) return true;
    index = tagEnd + 1;
  }
  return false;
};

/** Backend rename returns 200 with these substrings when items were skipped. */
export const renameResponseIndicatesBlockedItems = (message) => {
  if (!message || typeof message !== 'string') return false;
  const t = message.trim();
  if (!t) return false;
  const lower = t.toLowerCase();
  return lower.includes('already exists')
    || lower.includes('could not be renamed')
    || containsRedFontTag(t);
};

export const stripHtmlToPlainMessage = (html) => {
  if (!html || typeof html !== 'string') return '';
  // Linear scan to avoid regex backtracking on long messages.
  let result = '';
  let inTag = false;
  let pendingTag = '';
  for (let i = 0; i < html.length; i += 1) {
    const char = html[i];
    if (inTag) {
      pendingTag += char;
      if (char === '>') {
        inTag = false;
        pendingTag = '';
        result += ' ';
      }
      continue;
    }
    if (char === '<') {
      inTag = true;
      pendingTag = '<';
      continue;
    }
    result += char;
  }
  if (inTag && pendingTag) {
    result += pendingTag;
  }
  return collapseWhitespace(result);
};
